import {
  getDefaultTransition,
  Input as InputComponent,
  InputProps as InputComponentProps,
  Spacing,
} from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface InputProps extends InputComponentProps {
  clearable: boolean
  searchable: boolean
}

export const CreateNewContactButton = styled.button`
  display: flex;
  align-items: center;
  border: none;
  cursor: pointer;
  appearance: none;
`

export const ToggleIconWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

export const DropdownPagesLimit = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  padding: 0 ${Spacing.S16};
`

export const Input = styled(InputComponent)<InputProps>`
  ${({ clearable }) =>
    clearable &&
    `
    &:hover {
      ${ClearInputWrapper} {
        opacity: 1;
      }
    }
  `}

  ${({ searchable, disabled, selectLook }) =>
    !searchable &&
    !disabled &&
    selectLook &&
    css`
      cursor: pointer;
    `}
`

export const ClearInputWrapper = styled.div`
  opacity: 0;
  margin-right: ${Spacing.S8};
  ${getDefaultTransition('opacity')};

  &:last-child {
    margin-right: 0;
  }
`
